import { Errno, Exception, withErrno } from 'kerium';
import * as primitive from './primitives.js';
import { dynamicStructSize, isStructConstructor, isStructInstance } from './structs.shared.js';
import { isType } from './types.js';
import * as __field from './fields.internal.js';
function static_sizeof(type) {
    if (isType(type))
        return type.size;
    if (type === undefined || type === null)
        return 0;
    if (typeof type == 'object' && isType(type.constructor))
        return type.constructor.size;
    if (Array.isArray(type)) {
        let size = 0;
        for (let i = 0; i < type.length; i++)
            size += static_sizeof(type[i]);
        return size;
    }
    // primitive or character
    if (typeof type == 'string') {
        primitive.checkValid(type);
        return primitive.types[primitive.normalize(type)].size;
    }
    // eslint-disable-next-line @typescript-eslint/no-base-to-string
    throw new TypeError(`Unable to resolve size of \`${type.toString()}\``);
}
/**
 * Gets the size in bytes of a type
 */
export function sizeof(type) {
    const size = static_sizeof(type);
    if (isStructInstance(type) && type.constructor.isDynamic) {
        return (size + dynamicStructSize(type));
    }
    return size;
}
/**
 * Returns the offset (in bytes) of a field in a struct.
 */
export function offsetof(type, fieldName) {
    let constructor;
    if (isStructConstructor(type)) {
        if (type.isDynamic)
            throw withErrno('EINVAL', 'Cannot get offset of field in dynamic struct from the constructor');
        constructor = type;
    }
    else if (isStructInstance(type))
        constructor = type.constructor;
    else
        throw withErrno('EINVAL', 'Type is not a struct or struct constructor');
    const { fields } = constructor;
    const field = fields.find(f => f.name === fieldName);
    if (!field)
        throw withErrno('EINVAL', 'Struct does not have field: ' + fieldName);
    return isStructConstructor(type) ? field.offset : __field.offsetOf(type, field, true);
}
export class MemoryError extends Exception {
    address;
    constructor(err, address) {
        super(Errno[err]);
        this.address = address;
    }
}
